angular.module('memberPortal', ['ui.router', 'ui.bootstrap', 'infinite-scroll', 'shared', 'restangular', 'shared', 'filters', 'tandibar/ng-rollbar', 'ngMask', 'react']).run(["Restangular", "restangularInterceptors", "$rootScope", function(Restangular, restangularInterceptors, $rootScope) {
  return Restangular.addRequestInterceptor(restangularInterceptors.RequestInterceptor).addResponseInterceptor(restangularInterceptors.ResponseInterceptor);
}]).config(["$locationProvider", "$stateProvider", "$httpProvider", "RestangularProvider", "RollbarProvider", function($locationProvider, $stateProvider, $httpProvider, RestangularProvider, RollbarProvider) {
  var meta;
  meta = angular.element(document.querySelectorAll('meta[name=csrf-token]'));
  $httpProvider.interceptors.push('memberPortalHttp401Interceptor');
  $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token';
  $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  $locationProvider.html5Mode(true);
  RollbarProvider.init(window._rollbarConfig);
  RestangularProvider.setBaseUrl(`/websites/${window.DATA.domain}/members`);
  return $stateProvider.state('memberPortal', {
    url: '/websites/:domain/members',
    abstract: true,
    template: '<ui-view>'
  }).state('memberPortal.loginByEmail', {
    url: '/login',
    controller: 'MemberLoginCtrl',
    template: require('templates/member_portal/login/login_by_email.html.slim')
  }).state('memberPortal.loginByHash', {
    url: '/logins/:hash',
    controller: 'MemberLoginCtrl',
    template: require('templates/member_portal/login/login_by_hash.html.slim')
  }).state('memberPortal.forgotPin', {
    url: '/pins/new?m',
    controller: 'MemberLoginCtrl',
    template: require('templates/member_portal/login/forgot_pin.html.slim')
  }).state('memberPortal.bookings', {
    url: '/bookings?m',
    controller: 'BookingsCtrl',
    template: require('templates/member_portal/bookings/list.html.slim'),
    data: {
      title: 'Bookings'
    },
    resolve: {
      Bookings: ["Restangular", function(Restangular) {
        return Restangular.all('bookings');
      }]
    }
  }).state('memberPortal.pastBookings', {
    url: '/bookings/history?m',
    controller: 'BookingsCtrl',
    template: require('templates/member_portal/bookings/list.html.slim'),
    data: {
      title: 'Past Bookings'
    },
    resolve: {
      Bookings: ["Restangular", function(Restangular) {
        return Restangular.all('bookings').all('history');
      }]
    }
  }).state('memberPortal.events', {
    url: '/events?m&origin',
    controller: 'EventsCtrl',
    template: require('templates/member_portal/events/list.html.slim'),
    data: {
      title: 'Events'
    },
    resolve: {
      locations: ["Restangular", function(Restangular) {
        return Restangular.all('locations').getList({
          count: 200
        });
      }],
      instructors: ["Restangular", "DataService", function(Restangular, DataService) {
        if (DataService.show_instructor_filter) {
          return Restangular.all('instructors').getList({
            count: 200
          });
        } else {
          return [];
        }
      }],
      styles: ["Restangular", "DataService", function(Restangular, DataService) {
        if (DataService.show_style_filter && DataService.martial_arts_gym) {
          return Restangular.all('styles').getList({
            count: 1000
          });
        } else {
          return [];
        }
      }],
      eventTypes: ["Restangular", "DataService", function(Restangular, DataService) {
        if (DataService.show_event_type_filter) {
          return Restangular.all('event_types').getList({
            count: 1000
          });
        } else {
          return [];
        }
      }]
    }
  }).state('memberPortal.showEvent', {
    url: '/events/:id?m&origin',
    controller: 'ShowEventCtrl',
    template: require('templates/member_portal/events/show.html.slim'),
    data: {
      title: 'Event'
    },
    resolve: {
      event: ["$stateParams", "$http", "DataService", function($stateParams, $http, DataService) {
        var url;
        url = `/websites/${DataService.domain}/members/events/${$stateParams.id}`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }]
    }
  }).state('memberPortal.styles', {
    url: '/member_styles?m',
    controller: 'StylesCtrl',
    template: require('templates/member_portal/styles/list.html.slim'),
    data: {
      title: 'My MA Styles'
    },
    resolve: {
      styles: ["Restangular", function(Restangular) {
        return Restangular.all('member_styles').getList();
      }]
    }
  }).state('memberPortal.profile', {
    url: '/members/:id?m',
    controller: 'MemberProfileCtrl',
    template: require('templates/member_portal/profile/show.html.slim'),
    data: {
      title: 'Your Profile'
    }
  }).state('memberPortal.card', {
    url: '/members/:id/card?m',
    controller: 'MemberProfileCtrl',
    template: require('templates/member_portal/profile/card.html.slim'),
    data: {
      title: 'Membership ID Card'
    }
  }).state('memberPortal.membership', {
    url: '/memberships/:id?m',
    controller: 'MembershipCtrl',
    template: require('templates/member_portal/memberships/show.html.slim'),
    data: {
      title: 'Active Memberships'
    },
    resolve: {
      membership: ["$stateParams", "DataService", function($stateParams, DataService) {
        var memberships;
        memberships = DataService.member_details.memberships;
        return _.find(memberships, function(membership) {
          return membership.id === parseInt($stateParams.id, 10);
        });
      }]
    }
  }).state('memberPortal.membershipPlans', {
    url: '/membership_plans?m',
    controller: 'MembershipPlansCtrl',
    template: require('templates/member_portal/membership_plans/list.html.slim'),
    data: {
      title: 'Memberships'
    },
    resolve: {
      membershipPlans: ["Restangular", function(Restangular) {
        return Restangular.all('membership_plans').getList({
          count: 200
        });
      }]
    }
  }).state('memberPortal.membershipPlan', {
    url: '/membership_plans/:id?m',
    controller: 'MembershipPlanCtrl',
    template: require('templates/member_portal/membership_plans/show.html.slim'),
    data: {
      title: 'Purchase Membership'
    },
    resolve: {
      membershipPlans: ["Restangular", function(Restangular) {
        return Restangular.all('membership_plans').getList({
          count: 200
        });
      }],
      membershipPlan: ["membershipPlans", "$stateParams", function(membershipPlans, $stateParams) {
        return _.find(membershipPlans, function(plan) {
          return plan.id === parseInt($stateParams.id, 10);
        });
      }],
      membership: ["membershipPlan", "DataService", function(membershipPlan, DataService) {
        var memberships;
        memberships = DataService.member_details.memberships;
        return _.find(memberships, function(membership) {
          return membership.membership_plan_id === membershipPlan.id;
        });
      }]
    }
  });
}]);
